module.exports = __webpack_public_path__ + "img/seanet.cad99153.png";